export default __webpack_public_path__ + "static/media/organize_my_training.ba3cff9d.png";